import { useQuery } from '@tanstack/react-query';
import { fetchSamplingBlockReasons, type SamplingBlockReason } from '../services/samplingBlockReasonService';

export const useSamplingBlockReasons = () => {
  const { data: samplingBlockReasons = [], isLoading, error } = useQuery<SamplingBlockReason[]>({
    queryKey: ['samplingBlockReasons'],
    queryFn: fetchSamplingBlockReasons,
    staleTime: 5 * 60 * 1000, // 5 minutos
    retry: 3,
  });

  return { samplingBlockReasons, isLoading, error };
}; 